exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-dentrix-tsx": () => import("./../../../src/pages/dentrix.tsx" /* webpackChunkName: "component---src-pages-dentrix-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-point-click-care-tsx": () => import("./../../../src/pages/point-click-care.tsx" /* webpackChunkName: "component---src-pages-point-click-care-tsx" */)
}

